export default {
  contentfulSpaceId: process.env.VUE_APP_CONTENTFUL_SPACE_ID,
  contentfulHost: process.env.VUE_APP_CONTENTFUL_HOST,
  contentfulAccessToken: process.env.VUE_APP_CONTENTFUL_ACCESS_TOKEN,
  geocodingKey: process.env.VUE_APP_GEOCODING_KEY,
  googlePayMerchantId: process.env.VUE_APP_GOOGLE_PAY_MERCHANT_ID,
  tableServiceGateway: process.env.VUE_APP_PMB_GATEWAY_URL,
  sentryDsn: process.env.VUE_APP_SENTRY_DSN,
}
